import React from 'react'
import { BasePage as CngBasePage } from 'cng-web-lib'
import { ScopedCssBaseline } from '@mui/material';
import { SnackbarProvider } from 'src/contexts/era-package/SnackbarContext';
import ABIEntrySummaryTranslationProvider from '../contexts/ABIEntrySummaryTranslationContext';
import { AdminSettingsView } from './AdminSettingsView';
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap';

export const AdminSettingsPage = () => {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return <CngBasePage
    renderPage={(showSnackbar) => (
      <ABIEntrySummaryTranslationProvider>
        <ScopedCssBaseline>
          <SnackbarProvider>
            <AdminSettingsView />
          </SnackbarProvider>
        </ScopedCssBaseline>
      </ABIEntrySummaryTranslationProvider>)}
    extraCngBreadcrumbNameMap={breadcrumbNameMap}
  />
}
